import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import {
  Button,
  FormControl,
  FormControlLabel,
  OutlinedInput,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

type Props = {
  activeStep: any;
  handleSelectedAttachmentType: any;
  handleBack: any;
  handelNavigateBack: any;
  selectedAttachmentType: any;
  setSelectedAttachmentType: any;
  setOtherType: any;
  otherType: any;
};

const AttachmentType = (props: Props) => {
  const {
    activeStep,
    handleSelectedAttachmentType,
    handleBack,
    handelNavigateBack,
    selectedAttachmentType,
    setOtherType,
    setSelectedAttachmentType,
    otherType,
  } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedAttachmentType((event.target as HTMLInputElement).value);
  };

  return (
    <Box
      sx={{
        border: '1px solid #F2F4F7',
        borderRadius: '20px',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
      p={1}
    >
      <Box sx={{ p: 5 }}>
        <Typography variant="h5">Attachment Type</Typography>
        <Box
          mt={2}
          ml={3}
        >
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={selectedAttachmentType}
              onChange={handleChange}
            >
              <FormControlLabel
                value="PhysicianSignature"
                control={<Radio />}
                label="Physician Signature"
                sx={{ p: 1.5 }}
              />
              <FormControlLabel
                value="SUPERVISOR_SIGNATURE"
                control={<Radio />}
                label="Supervisor Signature"
                sx={{ p: 1.5 }}
              />
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <FormControlLabel
                  value="Other"
                  control={<Radio />}
                  label="Other"
                  sx={{ p: 1.5 }}
                />
                {selectedAttachmentType === 'Other' ? (
                  <OutlinedInput
                    value={otherType}
                    placeholder="Enter Attachment Type"
                    onChange={(e) => setOtherType(e.target.value)}
                  />
                ) : null}
              </Box>
            </RadioGroup>
          </FormControl>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
        <Box>
          <Button
            variant="outlined"
            disabled={activeStep === 0}
            startIcon={<KeyboardArrowLeft />}
            onClick={handleBack}
          >
            Back
          </Button>
        </Box>
        <Box>
          <Button
            sx={{ mr: 2, color: '#384250' }}
            onClick={handelNavigateBack}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            endIcon={<KeyboardArrowRight />}
            disabled={!selectedAttachmentType}
            onClick={handleSelectedAttachmentType}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AttachmentType;
